import { isSafe, IsSafeConfig } from 'redos-detector';
import { logger } from './logger';

export class SafeRegExp {
  private pattern: string;

  private regExp: RegExp;

  public flags: string;

  private params: IsSafeConfig | undefined;

  constructor(pattern: string, flags: string = '', params?: IsSafeConfig) {
    this.pattern = pattern;
    this.flags = flags;
    this.params = params;
    this.regExp = new RegExp(pattern, flags);
  }

  public test(str: string): boolean {
    const result = isSafe(this.regExp, this.params);
    if (result.safe) {
      return this.regExp.test(str);
    }
    logger.warn(`Pattern ${this.pattern} is unsafe.`);
    return false;
  }
}
